import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-error',
  imports: [TranslocoPipe, CommonModule],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss',
})
export class ErrorComponent {
  @Input() control!: AbstractControl;
  get isInvalid(): boolean {
    if (!this.control || !this.control.errors) return false;
    const isPrimitive =
      this.control.value === null || typeof this.control.value !== 'object';
    const valueNotEmpty =
      isPrimitive &&
      this.control.value !== null &&
      this.control.value !== '';
    const interacted = this.control.dirty || this.control.touched;
    return interacted || valueNotEmpty;
  }
  get controlErrors(): string[] {
    return this.control && this.control.errors
      ? Object.keys(this.control.errors)
      : [];
  }
}
